@reference "@glow/tailwind-config/reference.css";

.li {
  @apply list-none;
  @apply cursor-pointer;
  @apply sm:whitespace-nowrap;
  @apply px-[1.5em];
  @apply py-[0.75em];
}

.li:hover {
  @apply bg-gray-100;
  @apply rounded-sm;
}

.item {
  @apply mx-2;
}

.selected {
  @apply border-primary-500;
  @apply bg-primary-100;
  @apply border-solid;
  @apply border;
  @apply rounded-sm;
}

.disabled {
  @apply opacity-30;
  @apply cursor-not-allowed;
}
